export const selectApp = (state) => state.app;
export const selectAppLang = (state) => state.app.lang;
export const isLogin = (state) => state.app.isLogin;
